<div class="mb-searchbar-group clearfix" [ngStyle]="{'height': isCard ? '100%' : 'auto'}" [class.hide]="hidden">
    <div class="mb-sidepanel-mobile" title="Show menu">
        <!-- <span><a href="javascript:void(0)" (click)="ShowToDo()">&#187;</a></span> -->
    </div>
    <div [ngClass]="{'searchBarPanel':true, 'catalogue':isCatalogue }">
        <div class="input-group" *ngIf="profileView; else normal">
            <input #text type="text" autofocus id="global-search" placeholder="What would you like to do today?" (keyup.enter)="searchGlobal(text.value)" [(ngModel)]="speechData" />
            <span class="input-group-addon search-addon">
                <ng-container *ngIf="speechApi && !isBusy">
                    <mat-icon id="microfon-ic" title='Search by voice' (click)="activateSpeech()">keyboard_voice</mat-icon>
                </ng-container>
                <!-- <a *ngIf="!isBusy" id="search-ic" (click)="searchGlobal(text.value)">
                    <img src="../../assets/images/search.png" />
                </a> -->
                <div *ngIf="!isBusy" id="search-ic" (click)="searchGlobal(text.value)">
                    <mat-icon>search</mat-icon>
                </div>
                <div *ngIf="isBusy" class="spinner">
                    <div class="bounce1"></div>
                    <div class="bounce2"></div>
                    <div class="bounce3"></div>
                </div>
            </span>
        </div>
        <ng-template #normal>
            <div class="input-group">
                <!-- <div class="input-group-prepend dropdown" dropdown container="body"> -->
                    <!-- <button dropdownToggle class="btn dropdown-current-view no-outline" type="button" 
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{selectedValue}} View</button>
                    <ul class="dropdown-menu" *dropdownMenu>
                        <li [ngClass]="{'active': selectedValue == 'Current' }"><a #current class="dropdown-item select-search" (click)="changeView('Current')">Current View</a></li>
                        <li [ngClass]="{'active': selectedValue == 'Global'}"><a #global class="dropdown-item select-search" (click)="changeView('Global')">Global View</a></li>
                    </ul> -->
                    <!-- <ng-select [items]="valueSelection"
                        class="dropdown-current-view no-outline"
                        appendTo=".body-content"
                        (change)="changeView($event)"
                        [clearable]="false" 
                        [searchable]="false"
                        bindLabel="ItemDisplay"
                        bindValue="ItemValue"
                        [(ngModel)]="selectedValue"></ng-select>
                </div> -->
                <ng-container *ngIf="selectedValue == 'Current';else globalInput">
                    <input #searchTextbox type="text" [value]="setKeyword ? setKeyword : ''" class="form-control search-textbox" placeholder="Search in {{placeholder}}" 
                    (keyup.enter)="searchByKeyword(searchTextbox.value)" [disabled]="isBusy || !enableSearch">
                    <span [ngClass]="{'clear-search': true, 'show': searchTextbox.value && !isBusy}" (click)="searchByKeyword('')" title="Clear search"></span>
                    <span class="input-group-addon search-addon">
                        <ng-container *ngIf="speechApi && !isBusy && enableSearch" >
                            <mat-icon id="microfon-ic" title='Search by voice' (click)="activateSpeech()">keyboard_voice</mat-icon>
                        </ng-container>
                        <!-- <a *ngIf="!isBusy" id="search-ic" (click)="searchByKeyword(searchTextbox.value)">
                            <img src="../../assets/images/search.png" />
                        </a> -->
                        <div *ngIf="!isBusy && enableSearch" id="search-ic" (click)="searchByKeyword(searchTextbox.value)" title='Search'>
                            <mat-icon>search</mat-icon>
                        </div>
                        <div *ngIf="isBusy" class="spinner">
                            <div class="bounce1"></div>
                            <div class="bounce2"></div>
                            <div class="bounce3"></div>
                        </div>
                    </span>
                </ng-container>
                <ng-template #globalInput>
                    <input #text type="text" autofocus class="form-control search-textbox" placeholder="What would you like to do today?" (keyup.enter)="searchGlobal(text.value)" [(ngModel)]="speechData" />
                    <span class="input-group-addon search-addon">
                        <ng-container *ngIf="speechApi">
                            <mat-icon id="microfon-ic" title='Search by voice' (click)="activateSpeech()">keyboard_voice</mat-icon>
                        </ng-container>
                        <!-- <a id="search-ic" (click)="searchGlobal(text.value)">
                            <img src="../../assets/images/search.png" />
                        </a> -->
                        <div id="search-ic" (click)="searchGlobal(text.value)">
                            <mat-icon>search</mat-icon>
                        </div>
                    </span>
                </ng-template>
            </div>
        </ng-template>
        
    </div>
  </div>